import Vue from "vue";
import VueGtag from "vue-gtag";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueLazyLoad from "vue-lazyload";
import VScrollLock from "v-scroll-lock";
import VueMasonry from "vue-masonry-css";
import setMetaMixin from "./mixins/setMeta";

Vue.config.productionTip = false;

Vue.mixin(setMetaMixin);

Vue.use(
  VueGtag,
  {
    config: { id: "UA-173150379-1" }
  },
  router
);
Vue.use(VueLazyLoad);
Vue.use(VueMasonry);
Vue.use(VScrollLock);

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount("#app");
